/* ============================================================================
   tne-antes-depois.js — Carrossel de casos (Programa de Consultoras)
   DistribuidorTopBioEuropa | Site institucional B2B

   REESCRITO: a grelha de cards deu lugar a um CARROSSEL automático em loop,
   igual ao da secção de produtos. Cada card é horizontal (foto à esquerda,
   testemunho à direita) e o conjunto corre sozinho, pausando no hover/focus.

   Responsabilidades:
     1. Clonar os cards do track uma vez para o loop ser contínuo (a animação
        CSS desliza translateX -50% → 0, esquerda → direita, ou seja exactamente
        uma cópia). Velocidade proporcional ao nº de cards.
     2. Pausa no hover/focus é feita 100% por CSS (animation-play-state).

   prefers-reduced-motion: NÃO clona nem anima — o carrossel fica um row com
   scroll horizontal manual (classe .is-static, ver CSS). Os clones são
   puramente visuais (aria-hidden, sem ids, fora da ordem de tabulação).
   ============================================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAntesDepois(root) {
    if (!root || root.dataset.tneAntesDepoisInit === '1') return;
    root.dataset.tneAntesDepoisInit = '1';

    initCarousel(root);
  }

  function initCarousel(root) {
    var carousel = root.querySelector('[data-tne-ad-carousel]');
    var track = root.querySelector('[data-tne-ad-carousel-track]');
    if (!carousel || !track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    // Reduced-motion: sem animação nem clones — scroll manual.
    if (prefersReducedMotion) {
      carousel.classList.add('is-static');
      return;
    }

    // Duplica o conjunto de cards. Como o track passa a ter 2 cópias, a
    // animação translateX(-50%) termina exactamente onde começou → loop sem
    // costura. Os clones são decorativos: aria-hidden, sem ids, sem tabstop.
    originals.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      stripInteractivity(clone);
      track.appendChild(clone);
    });

    // Cards são largos (foto + texto) → mais lento que os produtos para dar
    // tempo de ler. ~7s por card, mínimo 24s no total.
    var seconds = Math.max(24, originals.length * 7);
    track.style.setProperty('--tne-marquee-duration', seconds + 's');

    carousel.classList.add('is-ready');
  }

  // Remove ids (evita duplicados no DOM) e tira os clones da ordem de
  // tabulação/leitura — são apenas a "segunda volta" visual do loop.
  function stripInteractivity(clone) {
    if (clone.id) clone.removeAttribute('id');
    Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) {
      el.removeAttribute('id');
    });
    Array.prototype.forEach.call(clone.querySelectorAll('a, button, input, [tabindex]'), function (el) {
      el.setAttribute('tabindex', '-1');
    });
  }

  function boot() {
    document.querySelectorAll('[data-tne-antes-depois]').forEach(initAntesDepois);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme Editor — re-inicializa quando a secção é recarregada.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tne-antes-depois]');
    if (root) {
      root.dataset.tneAntesDepoisInit = '';
      initAntesDepois(root);
    }
  });
})();
